import { EXOTEL_APIS } from "@/api_framework/api_config";
import { IBulkCartUpdatePayload, IBulkCartUpdateResponse } from "@/api_framework/api_modals/Exotel";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useBulkCartUpdateAPI = () => {
  const configuration = useConfiguration();
  const { captureError, toastNotification } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (bulkCartUpdatePayload: IBulkCartUpdatePayload) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: any = await axios
          .put(`${EXOTEL_APIS?.EXOTEL_BULK_CART_UPDATE?.baseURL}`, bulkCartUpdatePayload, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IBulkCartUpdateResponse>) => {
            if (res.data.status === true) {
              toastNotification(res.data.message);
              return { status: true };
            } else {
              return { status: false };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);

            return { status: false };
          });
        return response;
      } catch (e) {
        captureError(e);
      }
    },
    [captureError, toastNotification, sendCurl, configuration],
  );
  return { execute };
};
